var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.customisation.layout === 0)?_c('div',{staticClass:"w-screen"},[_c('Layout0Home')],1):_vm._e(),_vm._v(" "),(_vm.customisation.layout === 1)?_c('div',{staticClass:"w-screen"},[_c('Layout1Home')],1):_vm._e(),_vm._v(" "),(_vm.customisation.layout === 2)?_c('div',{staticClass:"w-screen"},[_c('Layout2Home')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }